import React from 'react'
import { useSelector } from 'react-redux'
import { Redirect, Route } from 'react-router'

const RoutePrivate = ({ children, ...rest }) => {
    const user_data = useSelector(state => state.user)
    
    return (
        <Route
            {...rest}
            render={({ location }) =>
                user_data.user !== null ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: "/login",
                            state: { from: location }
                        }}
                    />
                )
            }
        />
    )
}

export default RoutePrivate
